import { Section } from '../../components/Section'
import { Container } from '../../components/Container'
import { UserEdit } from '../../containers/users/UserEdit'
import { useParams } from 'react-router-dom'
import { useGetUser, useGetUserProperties } from 'BrokerTsLib/src/hooks/useUser'
import { Loading } from '../../components/Loading'
import { PageContent } from '../../containers/PageContent'

export const UserEditPage = () => {
  const { userId } = useParams()

  const { data: userData, isLoading: isUserLoading, isRefetching: isUserRefetching } = useGetUser(userId!)
  const { data: propertiesData, isLoading: isPropertiesLoading, isRefetching: isPropertiesRefetching } = useGetUserProperties(userId!)

  const isLoading = isUserLoading || isPropertiesLoading || isUserRefetching || isPropertiesRefetching
  const anyData = userData?.data && propertiesData?.data

  return (
    <Section>
      <Container>
        <PageContent>
          {isLoading || !anyData ? <Loading large /> :
            <UserEdit user={userData.data} properties={propertiesData.data} />}
        </PageContent>
      </Container>
    </Section>
  )
}
